export default __webpack_public_path__ + "static/media/hero-purple.95db2d26.jpg";